import { createFileRoute } from '@tanstack/react-router';
import { SportCreatePage } from '../pages/sports/sport-create-page';

export const Route = createFileRoute('/sports/new')({
  component: SportCreatePage,
});
